<template>
  <div class="arquivo-recebido">
    <div>
      <ArquivoBase
        :tipoArquivo="informacoesArquivo.tipoArquivo"
        :objetoArquivo="informacoesArquivo.objetoArquivo"
        @baixar-arquivo="$emit('baixar-arquivo', recuperarObjetoAcao.uuid)"
      />
    </div>
    <div class="linha-embaixo-arquivo-recebido" />
    <unicom-linha class="acoes-arquivo">
      <unicom-coluna sm="12" md="auto">
        <div class="medio texto-arquivo">
          Ao aprovar ou reprovar o arquivo, uma notificação será encaminhada a
          singular.
        </div>
      </unicom-coluna>
      <unicom-coluna class="ml-auto" sm="12" md="auto">
        <unicom-botao
          @click="$emit('reprovar-arquivo', recuperarObjetoAcao)"
          :altura="40"
          tipo="secundario"
          :largura="216"
        >
          REPROVAR
        </unicom-botao>
      </unicom-coluna>
      <unicom-coluna sm="12" md="auto">
        <unicom-botao
          @click="$emit('aprovar-arquivo', recuperarObjetoAcao)"
          :altura="40"
          :largura="216"
        >
          APROVAR
        </unicom-botao>
      </unicom-coluna>
    </unicom-linha>
  </div>
</template>

<script>
import ArquivoBase from "../../../ListaArquivos/TiposArquivos/ArquivoBase";
import { TIPOS_ARQUIVOS } from "../../../ListaArquivos/TiposArquivos/TiposArquivosEnum";

export default {
  components: {
    ArquivoBase
  },
  props: {
    informacoesArquivo: {
      type: Object,
      default: () => {
        return {
          tipoArquivo: TIPOS_ARQUIVOS.ANALISE,
          objetoArquivo: {
            nomeArquivo: "Certificado.jpg",
            tamanhoArquivo: this.formatarBytes(100000),
            dataEnvio: "12/01/2020",
            mostrarIconeExcluir: false
          }
        };
      }
    }
  },
  computed: {
    recuperarObjetoAcao() {
      const { id, uuid } = this.informacoesArquivo.objetoArquivo;

      return {
        id,
        uuid
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.arquivo-recebido {
  min-height: 185px;
  border-radius: 8px;
  box-shadow: 0px 2px 5px #00000029;
  background: #f1f2f1;

  .linha-embaixo-arquivo-recebido {
    margin: 0 24px;
    border-bottom: 1px solid #dee2e6;
  }

  .acoes-arquivo {
    padding: 24px;

    .texto-arquivo {
      width: 374px;
      padding-left: 48px;
    }
  }
}
</style>
